import * as React from "react";
import { Grid } from "@material-ui/core";
import { AutocompleteInput, Edit, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from "react-admin";
import { AarConditions } from "../../../../Enums/AarConditions";
import { AarStorageLocations } from "../../../../Enums/AarStorageLocations";
import { Titles } from "./Constant/Source";
import AarStorageUpdateHistory from "./Components/AarStorageUpdateHistory";
import CustomerInvisiblePage from "../../../../Components/Auth/CustomerInvisiblePage";

const AarStorageUpdate = props => {
  return (
    <>
      <CustomerInvisiblePage />
      <Edit
        {...props}
        mutationMode={"pessimistic"}
        onFailure={error => console.log(error)}
        title={Titles.edit}
        component="div"
      >
        <SimpleForm>
          <Grid container spacing={6} style={{ width: "100%" }}>
            <Grid item xs={6} md={4}>
              <SelectInput
                label="Storage"
                source="storage"
                choices={AarStorageLocations}
                optionText="Description"
                optionValue="Value"
                fullWidth
                variant="outlined"
                validate={required()}
              />
              <SelectInput
                label="Condition"
                source="condition"
                choices={AarConditions}
                optionText="Description"
                optionValue="Value"
                fullWidth
                variant="outlined"
                validate={required()}
              />
              <ReferenceInput
                label="Ref No"
                source="requestId"
                resource="refNo"
                reference={"pbhrequestorders/getpbhrequestlist"}
                filterToQuery={optionText => ({
                  refNo__contains: optionText,
                })}
                enableGetChoices={({ q }) => q && q.length >= 4}
              >
                <AutocompleteInput
                  source="requestId"
                  optionText="refNo"
                  optionValue="id"
                  variant="outlined"
                  fullWidth
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={6} md={4}>
              <TextInput source="pn" label="Pn" fullWidth variant="outlined" validate={required()} disabled />
              <TextInput source="pnDesc" label="Pn Description" fullWidth variant="outlined" />
            </Grid>
            <Grid item xs={6} md={4}>
              <TextInput source="sn" label="Sn" fullWidth variant="outlined" validate={required()} />
              <TextInput multiline minRows={5} source="note" label="Note" fullWidth variant="outlined" />
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
      <AarStorageUpdateHistory {...props} />
    </>
  );
};

export default AarStorageUpdate;
